/**
 * Display-only language and currency conversion.
 * Keeps Shopify country at US so products stay purchasable.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ameluna_market';

  var MARKET_LABELS = {
    US: 'English',
    JP: '日本語',
    ES: 'Español',
    FR: 'Français',
    DE: 'Deutsch',
    KR: '한국어',
    IT: 'Italiano',
    PT: 'Português',
    MY: 'Bahasa Melayu',
    RU: 'Русский',
    TW: '繁體中文',
    SE: 'Svenska',
    NL: 'Nederlands',
    TR: 'Türkçe',
    FI: 'Suomi',
  };

  var MARKETS = {
    US: { locale: 'en', currency: 'USD', symbol: '$' },
    JP: { locale: 'ja', currency: 'JPY', symbol: '¥' },
    ES: { locale: 'es', currency: 'EUR', symbol: '€' },
    FR: { locale: 'fr', currency: 'EUR', symbol: '€' },
    DE: { locale: 'de', currency: 'EUR', symbol: '€' },
    KR: { locale: 'ko', currency: 'KRW', symbol: '₩' },
    IT: { locale: 'it', currency: 'EUR', symbol: '€' },
    PT: { locale: 'pt-PT', currency: 'EUR', symbol: '€' },
    MY: { locale: 'ms', currency: 'MYR', symbol: 'RM' },
    RU: { locale: 'ru', currency: 'RUB', symbol: '₽' },
    TW: { locale: 'zh-TW', currency: 'TWD', symbol: 'NT$' },
    SE: { locale: 'sv', currency: 'SEK', symbol: 'kr' },
    NL: { locale: 'nl', currency: 'EUR', symbol: '€' },
    TR: { locale: 'tr', currency: 'TRY', symbol: '₺' },
    FI: { locale: 'fi', currency: 'EUR', symbol: '€' },
  };

  var UI_STRINGS = {
    ja: {
      HOME: 'ホーム',
      SERIES: 'シリーズ',
      CUSTOMIZE: 'カスタマイズ',
      'DIY CRAFT KIT': 'DIYクラフトキット',
      SALE: 'セール',
      Search: '検索',
      'Add to cart': 'カートに追加',
      Add: '追加',
      'Shop Now': '今すぐ購入',
      'Sold out': '売り切れ',
      'Country/region': '国/地域',
      'Language and currency': '言語と通貨',
      'New Drops': '新商品',
      'Best Sellers': 'ベストセラー',
      'Shop by Category': 'カテゴリー',
      Apply: '適用',
      Cart: 'カート',
      From: 'から',
      Account: 'アカウント',
      Menu: 'メニュー',
      'Phone Case': 'Phone Case',
      'Free Shipping for orders over $50': '50ドル以上のご注文で送料無料',
      'NEW RELEASE 🧡 Ameluna 🤍 available now 🤎': '新発売 🧡 Ameluna 🤍 好評発売中 🤎',
      'Popular sets from $36.99': '人気セット $36.99 から',
    },
    es: {
      HOME: 'INICIO',
      SERIES: 'SERIES',
      CUSTOMIZE: 'PERSONALIZAR',
      'DIY CRAFT KIT': 'KIT DIY',
      SALE: 'REBAJAS',
      Search: 'Buscar',
      'Add to cart': 'Añadir al carrito',
      Add: 'Añadir',
      'Shop Now': 'Comprar ahora',
      'Sold out': 'Agotado',
      'New Drops': 'Novedades',
      'Best Sellers': 'Más vendidos',
      'Shop by Category': 'Comprar por categoría',
      From: 'Desde',
    },
    fr: {
      HOME: 'ACCUEIL',
      SERIES: 'SÉRIES',
      CUSTOMIZE: 'PERSONNALISER',
      'DIY CRAFT KIT': 'KIT DIY',
      SALE: 'SOLDES',
      Search: 'Rechercher',
      'Add to cart': 'Ajouter au panier',
      Add: 'Ajouter',
      'Shop Now': 'Acheter',
      'Sold out': 'Épuisé',
      'New Drops': 'Nouveautés',
      'Best Sellers': 'Meilleures ventes',
      'Shop by Category': 'Acheter par catégorie',
      From: 'À partir de',
    },
    de: {
      HOME: 'START',
      SERIES: 'SERIEN',
      CUSTOMIZE: 'ANPASSEN',
      'DIY CRAFT KIT': 'DIY-KIT',
      SALE: 'SALE',
      Search: 'Suchen',
      'Add to cart': 'In den Warenkorb',
      Add: 'Hinzufügen',
      'Shop Now': 'Jetzt shoppen',
      'Sold out': 'Ausverkauft',
      'New Drops': 'Neuheiten',
      'Best Sellers': 'Bestseller',
      'Shop by Category': 'Nach Kategorie',
      From: 'Ab',
    },
    ko: {
      HOME: '홈',
      SERIES: '시리즈',
      CUSTOMIZE: '커스터마이즈',
      'DIY CRAFT KIT': 'DIY 키트',
      SALE: '세일',
      Search: '검색',
      'Add to cart': '장바구니에 담기',
      Add: '추가',
      'Shop Now': '지금 구매',
      'Sold out': '품절',
      'New Drops': '신상품',
      'Best Sellers': '베스트셀러',
      'Shop by Category': '카테고리별',
      From: '부터',
    },
    it: {
      HOME: 'HOME',
      SERIES: 'SERIE',
      CUSTOMIZE: 'PERSONALIZZA',
      'DIY CRAFT KIT': 'KIT FAI DA TE',
      SALE: 'SALDI',
      Search: 'Cerca',
      'Add to cart': 'Aggiungi al carrello',
      Add: 'Aggiungi',
      'Sold out': 'Esaurito',
      'New Drops': 'Novità',
      'Best Sellers': 'Più venduti',
      From: 'Da',
    },
    'pt-PT': {
      HOME: 'INÍCIO',
      SERIES: 'SÉRIES',
      CUSTOMIZE: 'PERSONALIZAR',
      'DIY CRAFT KIT': 'KIT DIY',
      SALE: 'SALE',
      Search: 'Pesquisar',
      'Add to cart': 'Adicionar ao carrinho',
      Add: 'Adicionar',
      'Sold out': 'Esgotado',
      From: 'Desde',
    },
    ms: {
      HOME: 'LAMAN UTAMA',
      SERIES: 'SIRI',
      CUSTOMIZE: 'SUAIKAN',
      'DIY CRAFT KIT': 'KIT DIY',
      SALE: 'JUALAN',
      Search: 'Cari',
      'Add to cart': 'Tambah ke troli',
      Add: 'Tambah',
      'Sold out': 'Habis dijual',
      From: 'Dari',
    },
    ru: {
      HOME: 'ГЛАВНАЯ',
      SERIES: 'СЕРИИ',
      CUSTOMIZE: 'НАСТРОИТЬ',
      'DIY CRAFT KIT': 'DIY НАБОР',
      SALE: 'РАСПРОДАЖА',
      Search: 'Поиск',
      'Add to cart': 'В корзину',
      Add: 'Добавить',
      'Sold out': 'Нет в наличии',
      From: 'От',
    },
    'zh-TW': {
      HOME: '首頁',
      SERIES: '系列',
      CUSTOMIZE: '客製化',
      'DIY CRAFT KIT': 'DIY 手工包',
      SALE: '特賣',
      Search: '搜尋',
      'Add to cart': '加入購物車',
      Add: '加入',
      'Sold out': '已售完',
      'New Drops': '新品',
      'Best Sellers': '熱銷商品',
      'Shop by Category': '依分類選購',
      From: '起',
    },
    sv: {
      HOME: 'HEM',
      SERIES: 'SERIER',
      CUSTOMIZE: 'ANPASSA',
      'DIY CRAFT KIT': 'DIY-KIT',
      SALE: 'REA',
      Search: 'Sök',
      'Add to cart': 'Lägg i varukorgen',
      Add: 'Lägg till',
      'Sold out': 'Slutsåld',
      From: 'Från',
    },
    nl: {
      HOME: 'HOME',
      SERIES: 'SERIES',
      CUSTOMIZE: 'AANPASSEN',
      'DIY CRAFT KIT': 'DIY-KIT',
      SALE: 'SALE',
      Search: 'Zoeken',
      'Add to cart': 'In winkelwagen',
      Add: 'Toevoegen',
      'Sold out': 'Uitverkocht',
      From: 'Vanaf',
    },
    tr: {
      HOME: 'ANA SAYFA',
      SERIES: 'SERİLER',
      CUSTOMIZE: 'ÖZELLEŞTİR',
      'DIY CRAFT KIT': 'DIY KİT',
      SALE: 'İNDİRİM',
      Search: 'Ara',
      'Add to cart': 'Sepete ekle',
      Add: 'Ekle',
      'Sold out': 'Tükendi',
      From: 'Başlangıç',
    },
    fi: {
      HOME: 'ETUSIVU',
      SERIES: 'SARJAT',
      CUSTOMIZE: 'MUKAUTA',
      'DIY CRAFT KIT': 'DIY-PAKKAUS',
      SALE: 'ALE',
      Search: 'Hae',
      'Add to cart': 'Lisää ostoskoriin',
      Add: 'Lisää',
      'Sold out': 'Loppuunmyyty',
      From: 'Alkaen',
    },
  };

  var rateCache = {};
  var PRICE_SELECTOR =
    '.cc-card__price-sale, .cc-card__price-compare, .main-product__price-sale, .main-product__price-compare, .product-card__price, .product-card__atc, .cart-item__price, .cart-drawer__subtotal span:last-child, .choose-size__price';

  var TRANSLATE_SELECTOR =
    '.header__menu-item--top span, .header__menu-item span, .announcement-bar__text, .announcement-bar__message, .product-card__atc, .product-card__atc-label, .cc-card__add, button.product-card__atc, .choose-size__add-label, h2, h3, summary, label, input[placeholder], .slideshow__btn, .button';

  function getStoredMarket() {
    if (window.AmelunaMarket && window.AmelunaMarket.getStoredMarket) {
      return window.AmelunaMarket.getStoredMarket();
    }
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function getDisplayCountry() {
    var stored = getStoredMarket();
    return (stored && stored.country) || 'US';
  }

  function getMarket(country) {
    return MARKETS[country] || MARKETS.US;
  }

  function parseUsdAmount(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^\d.,]/g, '').replace(/,/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function formatMoney(amount, market) {
    var digits = market.currency === 'JPY' || market.currency === 'KRW' ? 0 : 2;
    var formatted = amount.toLocaleString(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });

    if (market.currency === 'USD') return '$' + formatted;
    if (market.currency === 'EUR') return '€' + formatted;
    if (market.currency === 'JPY') return '¥' + formatted;
    return market.symbol + formatted;
  }

  function fetchRate(currency) {
    if (currency === 'USD') return Promise.resolve(1);
    if (rateCache[currency]) return Promise.resolve(rateCache[currency]);

    return fetch('https://api.frankfurter.app/latest?from=USD&to=' + encodeURIComponent(currency))
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var rate = data && data.rates && data.rates[currency];
        if (!rate) throw new Error('Missing rate');
        rateCache[currency] = rate;
        return rate;
      })
      .catch(function () {
        return {
          JPY: 150,
          EUR: 0.92,
          KRW: 1350,
          MYR: 4.7,
          RUB: 92,
          TWD: 32,
          SEK: 10.5,
          TRY: 32,
        }[currency] || 1;
      });
  }

  function markOriginalPrices() {
    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      if (el.dataset.usdPrice) return;
      if (el.matches('.product-card__atc, .cc-card__add, button.product-card__atc')) return;
      var usd = parseUsdAmount(el.textContent);
      if (usd == null) return;
      el.dataset.usdPrice = String(usd);
    });
  }

  function convertPrices(rate, market, locale) {
    var fromLabel = (UI_STRINGS[locale] && UI_STRINGS[locale].From) || 'From';
    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      if (el.matches('.product-card__atc, .cc-card__add, button.product-card__atc')) return;
      var usd = parseFloat(el.dataset.usdPrice);
      if (isNaN(usd)) return;
      var converted = usd * rate;
      if (el.textContent.trim().indexOf('From ') === 0) {
        el.textContent = fromLabel + ' ' + formatMoney(converted, market);
      } else {
        el.textContent = formatMoney(converted, market);
      }
    });
  }

  function translateUi(locale) {
    if (locale === 'en') return;
    var dict = UI_STRINGS[locale];
    if (!dict) return;

    document.documentElement.lang = locale;

    Object.keys(dict).forEach(function (source) {
      var target = dict[source];
      if (source === target) return;

      document.querySelectorAll(TRANSLATE_SELECTOR).forEach(function (el) {
        if (el.children.length > 0 && !el.matches('input[placeholder]')) return;
        if (el.tagName === 'INPUT') {
          if (el.placeholder === source) el.placeholder = target;
          return;
        }
        var text = el.textContent.trim();
        if (text === source) el.textContent = target;
      });
    });

    document.querySelectorAll('body *').forEach(function (el) {
      if (el.children.length) return;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
      var text = el.textContent.trim();
      if (dict[text]) el.textContent = dict[text];
    });
  }

  function updateHeader(market, country) {
    document.querySelectorAll('form.localization-form--market').forEach(function (form) {
      var textEl = form.querySelector('.localization-selector__text');
      if (!textEl) return;

      if (form.closest('.localization-selectors--drawer')) {
        var label = MARKET_LABELS[country] || MARKET_LABELS.US;
        textEl.textContent = label + ' (' + market.currency + ' ' + market.symbol + ')';
      } else {
        textEl.textContent = market.currency;
      }
    });

    document.querySelectorAll('form.localization-form--market [data-market-select]').forEach(function (item) {
      var active = item.dataset.country === country;
      item.classList.toggle('disclosure__link--active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function applyMarket() {
    if (window.Shopify && Shopify.country && Shopify.country !== 'US') return;

    var country = getDisplayCountry();
    var market = getMarket(country);

    markOriginalPrices();
    updateHeader(market, country);
    translateUi(market.locale);

    if (market.currency === 'USD') return;

    fetchRate(market.currency).then(function (rate) {
      convertPrices(rate, market, market.locale);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMarket);
  } else {
    applyMarket();
  }
})();
